export default __webpack_public_path__ + "static/media/findMyWay.43ec9312.png";